import {
  useEditPipeline,
  useIsEditPipelineYAMLValid,
  useSaveYAMLChangesHandler,
  useYAMLHasChanges,
} from '../../../EditPipelinePage/EditPipelinePage.hooks'
import useSaveChangesError from '../../../EditPipelinePage/SaveChanges/hooks/useSaveChangesError'
import {usePipelineId} from '../../../hooks/pipeline'

export const useSaveChangesState = () => {
  const editPipeline = useEditPipeline()
  const isEditPipelineYAMLValid = useIsEditPipelineYAMLValid()
  const yamlHasChanges = useYAMLHasChanges()
  const [_, saveYAMLChangesResult] = useSaveYAMLChangesHandler()

  const pipelineId = usePipelineId()

  const saveChangesError = useSaveChangesError(pipelineId)

  const hasErrors = !isEditPipelineYAMLValid || saveChangesError.hasErrors
  const hasChanges = yamlHasChanges || editPipeline.hasChanges
  const isLoading = saveYAMLChangesResult.isLoading || editPipeline.isLoading

  return {
    hasErrors,
    hasChanges,
    isLoading,
  }
}
